module.exports = __webpack_public_path__ + "static/media/Bank.c555bad9.svg";